//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'Index',
  props: {
    navTitle: {
      type: String,
      default: ''
    }
  },
  data() {
    return {

    }
  },
  mounted() {
  },

  methods: {
    gotoBtn() {
      this.$router.go(-1)
    }

  }
}



// WEBPACK FOOTER //
// ./src/components/vanNavBar/index.vue